import { message, Modal, Popconfirm, Select, Table, Tag } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import { useHistory, useLocation } from "react-router-dom";
import {
  DeleteIcon,
  EditIcon,
  PropsFilter,
  RenderTable,
} from "../../../../config";
import { Wrapper } from "./style";
import Pagination from "../../../../components/pagination";
import AddCatalog from "./lib/add";
import { MakeApiCall } from "../../../../apis";
import { LoadingModal } from "../../../../components/upload-modals";

export default function LocationCatalog() {
  const history = useHistory();
  const location = useLocation();

  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  const [menuList, setMenuList] = useState([]);
  const [menuLoading, setMenuLoading] = useState(true);

  const [totalPage, setTotalPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [page, setPage] = useState(1);

  const [status, setStatus] = useState(null);
  const [sortFilters, setSortFilters] = useState({
    field_name: "title",
    sort_by: "asc",
  });

  const handleEdit = (row) => {
    history.push(
      `${location?.pathname}${location?.search}${
        location?.search ? "&" : "?"
      }viewType=edit&id=${row?.id}`
    );
  };

  const deleteRow = async (id) => {
    try {
      const response = await MakeApiCall(
        `location/${id}`,
        "delete",
        null,
        true
      );
      if (response?.status) {
        message.destroy();
        Modal.destroyAll();
        setList((pre) => pre.filter((d) => d?.id !== id));
        message.success(response?.message);
      } else {
        message.destroy();
        Modal.destroyAll();
        message.warning(response?.message);
      }
    } catch (error) {
      Modal.destroyAll();
    }
  };
  const handleDelete = (id) => {
    LoadingModal("Location Catalog", "Deleting...");
    deleteRow(id);
  };

  const columns = [
    {
      title: "#",
      align: "center",
      render: (_, __, i) => {
        return (
          <div className="d-flex justify-content-center w-100">{_?.key}</div>
        );
      },
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) => (
        <span>
          <a onClick={() => handleEdit(record)} className="me-2">
            {EditIcon}
          </a>
          <Popconfirm
            title="Delete the location"
            description="Are you sure to delete this location?"
            okText="Yes"
            onConfirm={() => handleDelete(record.id)}
            placement="left"
            cancelText="No"
          >
            <a href="#" className="me-2">
              {DeleteIcon}
            </a>
          </Popconfirm>
        </span>
      ),
    },

    {
      title: "Menu item",
      dataIndex: "menu_item",
      key: "menu_item",
      filterIndex: "menu_item",
      // defaultSort: true,
      // sorter: (a, b) => a?.menu_item?.localeCompare(b?.menu_item),
      // sortDirections: ["ascend"],
      render: (e, row) => {
        return <span>{e || "-"}</span>;
      },
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      filterIndex: "title",
    },
    {
      title: "Slug",
      dataIndex: "slug",
      key: "slug",
      filterIndex: "slug",
      render: (e, row) => {
        return <span>{e || "-"}</span>;
      },
    },

    // {
    //   title: "Created (ET)",
    //   dataIndex: "created_at",
    //   key: "created_at",
    //   filterIndex: "created_at",
    //   render: (e) => {
    //     return moment(new Date(parseInt(e) * 1000))
    //       .tz("America/New_York")
    //       .format("MM/DD/YYYY hh:mm A");
    //   },
    // },
    {
      title: "Last Updated (ET)",
      dataIndex: "updated_at",
      key: "updated_at",
      filterIndex: "updated_at",
      render: (e) => {
        return moment(new Date(parseInt(e) * 1000))
          .tz("America/New_York")
          .format("MM/DD/YYYY hh:mm A");
      },
    },
    {
      title: "Is Pending",
      dataIndex: "is_pending",
      render: (e, row) => {
        return (
          <Tag color={e == 1 ? "orange" : "success"}>
            {e == 1 ? "Pending" : "Done"}
          </Tag>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (e, row) => {
        return (
          <span className={e == 1 ? "active-seller" : "inactive-seller"}>
            {e == 1 ? "Active" : "Inactive"}
          </span>
        );
      },
    },
  ];

  const getList = async (data) => {
    // `location?page=${data?.page || page || 1}&per-page=${
    //     data?.pageSize || pageSize
    //   }&isAll=0&field_name=${data?.field_name || ""}&sort_by=${
    //     data?.sort_by || ""
    //   }`,
    const response = await MakeApiCall(`location?isAll=1`, "get", null, true);

    if (response?.status) {
      setList(
        response?.data?.records?.map((d, i) => ({ ...d, key: i + 1 })) || []
      );
      // setTotalPage(response?.data?.pagination?.totalCount || 0);
      setLoading(false);
    } else {
      // setTotalPage(0);
      setLoading(false);
      message.warning(response?.message);
    }
  };
  const getMenuList = async (data) => {
    setMenuLoading(true);
    const response = await MakeApiCall(`menu-item?isAll=1`, "get", null, true);

    if (response?.status) {
      setMenuList(
        Object.entries(response?.data || {})?.map(([key, value]) => ({
          title: key,
          label: key,
          options: Object?.entries(value || {})?.map(([key_, value_]) => ({
            label: value_,
            value: key_,
          })),
        })) || []
      );

      setMenuLoading(false);
    } else {
      setTotalPage(0);
      setMenuLoading(false);
      message.warning(response?.message);
    }
  };

  const s2ab = (s) => {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xff;
    }
    return buf;
  };

  const downloadExcel = (data) => {
    const wb = XLSX.utils.book_new();
    message.destroy();
    const ws = XLSX.utils.json_to_sheet(
      data?.map((d, i) => ({
        ID: i + 1,
        "Menu Item": d?.menu_item,
        Title: d?.title,
        Slug: d?.slug,
        "Last Updated (ET)": moment(new Date(parseInt(d?.updated_at) * 1000))
          .tz("America/New_York")
          .format("MM/DD/YYYY hh:mm A"),
        "Is Pending": d?.is_pending == 1 ? "Pending" : "Done",
        Status: d?.status == 1 ? "Active" : "Inactive",
      }))
    );
    XLSX.utils.book_append_sheet(wb, ws, "Location Catalog");

    const excelBinaryString = XLSX.write(wb, {
      bookType: "xlsx",
      type: "binary",
    });

    const blob = new Blob([s2ab(excelBinaryString)], {
      type: "application/octet-stream",
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `Location Catalog.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    message.destroy();
  };

  const pageType = new URLSearchParams(location.search)?.get("viewType");
  const selectedID = new URLSearchParams(location.search)?.get("id");

  const updateUrl = (url) => {
    const urlObj = new URL("http://example.com" + url);
    urlObj.searchParams.delete("viewType");
    urlObj.searchParams.delete("id");
    return urlObj.pathname + urlObj.search;
  };

  const updatedUrl = updateUrl(`${location?.pathname}${location?.search}`);

  useEffect(() => {
    setLoading(true);
    getList({ ...sortFilters });

    setMenuLoading(true);
    getMenuList();
    return () => {};
  }, []);

  if (pageType) {
    return (
      <AddCatalog
        setList={setList}
        pageType={pageType}
        id={selectedID}
        getList={() => getList({ ...sortFilters })}
        menuList={menuList}
        menuLoading={menuLoading}
        setVisible={() => {
          getList({ ...sortFilters });
          history.push(updatedUrl);
        }}
      />
    );
  }
  return (
    <Wrapper id="kt_content_container" className="custom-ui">
      <div className="row g-2">
        <div className="col-xxl-12">
          <div className="card card-xxl-stretch">
            <div className="card-header">
              <div className="card-title">Location Catalog</div>
              <div className="card-toolbar">
                <Select
                  placeholder="Status"
                  options={[
                    {
                      label: "Pending",
                      value: "1",
                    },
                    {
                      label: "Done",
                      value: "0",
                    },
                  ]}
                  onChange={(e) => {
                    setStatus(e);
                  }}
                  value={status}
                  allowClear
                  className="w-100px me-3"
                />

                <a
                  className="add-btn "
                  onClick={() => {
                    history.push(
                      `${location?.pathname}${location?.search}${
                        location?.search ? "&" : "?"
                      }viewType=add`
                    );
                  }}
                >
                  <svg
                    width={16}
                    height={16}
                    className="me-2"
                    fill="#ffffff"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M15 2.016H9v6.987H2v6h7v6.987h6v-6.987h7v-6h-7V2.016Z" />
                  </svg>
                  Add
                </a>
                <div
                  className="ms-3"
                  style={{
                    background: "#00B660",
                    borderRadius: 6,
                    padding: "8px 15px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    downloadExcel(
                      list
                        ?.sort((a, b) =>
                          a?.menu_item?.localeCompare(b?.menu_item)
                        )
                        ?.filter((d) =>
                          status === "0"
                            ? d?.is_pending === 0
                            : status === "1"
                            ? d?.is_pending === 1
                            : d
                        )
                    );
                  }}
                >
                  <div
                    style={{
                      color: "#FAFAFB",
                      fontSize: 13,

                      fontWeight: 500,
                      letterSpacing: 0.1,
                      wordWrap: "break-word",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={20}
                      height={20}
                      viewBox="0 0 24 24"
                      fill="none"
                      className="me-3"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M13 18.9656L13.3892 18.6653C13.8265 18.328 14.4544 18.409 14.7918 18.8463C15.1291 19.2836 15.0481 19.9115 14.6108 20.2489L12.6277 21.7787C12.5675 21.8274 12.5025 21.8682 12.4342 21.901C12.3808 21.928 12.309 21.9545 12.234 21.9725C12.1375 21.9951 12.0448 22.0033 11.953 21.9989C11.812 21.9924 11.6786 21.9567 11.5588 21.8976C11.4931 21.8654 11.4305 21.8257 11.3723 21.7787L9.38919 20.2489C8.9519 19.9115 8.87088 19.2836 9.20823 18.8463C9.54557 18.409 10.1735 18.328 10.6108 18.6653L11 18.9656V8.45711C11 7.90482 11.4477 7.45711 12 7.45711C12.5523 7.45711 13 7.90482 13 8.45711V18.9656ZM12.5 2C15.0609 2 17.2376 3.76105 17.8369 6.17236C20.2436 6.77356 22 8.95407 22 11.518C22 14.3327 19.8828 16.6868 17.1101 16.9939C16.5612 17.0547 16.0669 16.659 16.0061 16.1101C15.9453 15.5612 16.341 15.0669 16.8899 15.0061C18.6514 14.8109 20 13.3114 20 11.518C20 9.71741 18.6408 8.21401 16.8706 8.02783C16.4009 7.97843 16.0298 7.60718 15.9806 7.13748C15.7947 5.36183 14.2947 4 12.5 4C10.7037 4 9.20292 5.36415 9.01891 7.14171C8.96154 7.69596 8.46222 8.0964 7.90874 8.03205C7.77394 8.01638 7.63757 8.00847 7.5 8.00847C5.56748 8.00847 4 9.57926 4 11.518C4 13.3114 5.34862 14.8109 7.11011 15.0061C7.65903 15.0669 8.05473 15.5612 7.99392 16.1101C7.93311 16.659 7.43882 17.0547 6.88989 16.9939C4.11715 16.6868 2 14.3327 2 11.518C2 8.57497 4.30383 6.17018 7.20435 6.01629C7.85706 3.68561 9.99449 2 12.5 2Z"
                        fill="white"
                      />
                    </svg>
                    Export
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body scroll-show pt-0 pb-0">
              <Table
                dataSource={list
                  ?.sort((a, b) => a?.menu_item?.localeCompare(b?.menu_item))
                  ?.filter((d) =>
                    status === "0"
                      ? d?.is_pending === 0
                      : status === "1"
                      ? d?.is_pending === 1
                      : d
                  )
                  ?.map((d, i) => ({ ...d, key: i + 1 }))}
                // onChange={handleChange}
                columns={columns?.map((d) => ({
                  ...d,
                  className:
                    d?.title === "#" ? "maxWidth-table" : "minWidth-table",
                  ...(d?.filterIndex ? PropsFilter(d?.filterIndex) : ""),
                  render: (props, row, index) =>
                    RenderTable(props, row, index, d),
                }))}
                fixed={true}
                sticky={{
                  offsetHeader: "0px",
                }}
                loading={loading}
                pagination={{
                  size: "default",
                  defaultPageSize: 100,
                  showSizeChanger: true,
                }}
                rowClassName={(record, index) => {
                  return index % 2 === 0 ? "even-row" : "odd-row";
                }}
                bordered
                size="small"
                rowKey={"key"}
                scroll={{ x: "max-content", y: "calc(100vh - 410px)" }}
              />
            </div>
            <div className="card-footer d-none pt-0 pb-5">
              <Pagination
                loading={loading}
                pageSize={pageSize}
                page={page}
                totalPage={totalPage}
                onPerPage={(e) => {
                  setLoading(true);
                  setPageSize(e);
                  setPage(1);
                  getList({
                    page: 1,
                    pageSize: e,
                    ...sortFilters,
                  });
                }}
                onPageNo={(e) => {
                  setLoading(true);
                  setPage(e);
                  getList({
                    page: e,
                    ...sortFilters,
                  });
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
}
